import React, { Component } from 'react'
import { Provider, inject } from 'mobx-react'
import Store from './store'
import style from './style.module.less'
import {
  PLATFORM_MARKETING,
  SOCIAL_MARKETING,
  OFFLINE_MARKETING
} from './config'
import { HeaderView } from '@merchant-backend/common-components'

const ServiceItem = inject('store')(({ item, store }) => {
  const { bg, img, product_id, name, title, des } = item

  return (
    <div
      className={style.item}
      style={{
        backgroundColor: bg,
        backgroundImage: `url(${img})`
      }}
      onClick={() => store.goToService(product_id, name, 'statistic')}
    >
      <div className={style.text}>
        <p className={style.title}>{title}</p>
        <p className={style.description}>{des}</p>
      </div>
    </div>
  )
})

export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    return (
      <HeaderView contentStyle={{ padding: 0 }}>
        <Provider store={this.store}>
          <ul className={style.content}>
            <li>
              <p className={style.tag}>平台营销</p>
              <div className={style.tagWrap}>
                {PLATFORM_MARKETING.map((item, index) => (
                  <ServiceItem item={item} key={index} />
                ))}
              </div>
            </li>

            <li>
              <p className={style.tag}>社交营销</p>
              <div className={style.tagWrap}>
                {SOCIAL_MARKETING.map((item, index) => (
                  <ServiceItem item={item} key={index} />
                ))}
              </div>
            </li>

            <li>
              <p className={style.tag}>线下营销</p>
              <div className={style.tagWrap}>
                {OFFLINE_MARKETING.map((item, index) => (
                  <ServiceItem item={item} key={index} />
                ))}
              </div>
            </li>
          </ul>
        </Provider>
      </HeaderView>
    )
  }
}
